export default __webpack_public_path__ + "static/media/arrow-right-black.f7a965bd.svg";